export default "__VITE_ASSET__d59f94b6__"